import React, { useState } from "react";
import "../styles/TransactionReport.css";

export default function TransactionReport() {
  const [filters, setFilters] = useState({
    fromDate: "",
    toDate: "",
    branch: "",
    accountNumber: "",
    customerId: "",
  });

  const handleChange = (e) => {
    setFilters({ ...filters, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log(filters);
  };

  return (
    <div className="TransactionReport">
      {/* FILTER SECTION */}
      <section className="TransactionReport-filter-section">
        <h2>Transaction Filter</h2>
        <p>Use filter to see more precised report</p>
        <form onSubmit={handleSubmit} className="TransactionReport-filter-form">
          <div className="TransactionReport-form-group">
            <label>From Date</label>
            <input type="date" name="fromDate" value={filters.fromDate} onChange={handleChange} />
          </div>
          <div className="TransactionReport-form-group">
            <label>To Date</label>
            <input type="date" name="toDate" value={filters.toDate} onChange={handleChange} />
          </div>
          <div className="TransactionReport-form-group">
            <label>Choose Branch</label>
            <select name="branch" value={filters.branch} onChange={handleChange}>
              <option value="">Select branch</option>
              <option value="Branch A">Branch A</option>
              <option value="Branch B">Branch B</option>
            </select>
          </div>
          <div className="TransactionReport-form-group">
            <label>Account Number</label>
            <input type="text" name="accountNumber" value={filters.accountNumber} onChange={handleChange} placeholder="Enter account number" />
          </div>
          <div className="TransactionReport-form-group">
            <label>Customer Id</label>
            <input type="text" name="customerId" value={filters.customerId} onChange={handleChange} placeholder="Enter customer id" />
          </div>

          <button type="submit" className="TransactionReport-filter-button">Submit</button>
        </form>
      </section>

      {/* REPORT SECTION */}
      <section className="TransactionReport-report-section">
        <h2>Transaction Report</h2>
        <div className="TransactionReport-report-controls">
          <label>
            Search:
            <input type="text" placeholder="Search..." />
          </label>
          <label>
            Show
            <select>
              <option>10</option>
              <option>25</option>
              <option>50</option>
            </select>
            entries
          </label>
        </div>

        <div className="TransactionReport-table-responsive">
          <table className="TransactionReport-table">
            <thead>
              <tr>
                <th>SN</th>
                <th>Cus Name</th>
                <th>Cus Aadhar</th>
                <th>Account Number</th>
                <th>Transaction Amount</th>
                <th>Transaction Factor</th>
                <th>Transaction Source</th>
                <th>Approved By</th>
                <th>Requested By</th>
                <th>Requested Date</th>
                <th>Approval Date</th>
              </tr>
            </thead>
            <tbody>
              {[
                {
                  sn: 1,
                  name: "archana singh",
                  aadhar: "123456789369",
                  account: "MUZsa00011",
                  amount: "100.00",
                  factor: "CR",
                  source: "CASH",
                  approvedBy: "Demo Manager",
                  requestedBy: "Demo Manager",
                  requestedDate: "25 June 2025",
                  approvalDate: "25 June 2025",
                },
                {
                  sn: 2,
                  name: "aakash",
                  aadhar: "767898765456",
                  account: "H02sa00010",
                  amount: "100.00",
                  factor: "CR",
                  source: "CASH",
                  approvedBy: "AKASH",
                  requestedBy: "AKASH",
                  requestedDate: "13 May 2025",
                  approvalDate: "13 May 2025",
                },
              ].map((row, i) => (
                <tr key={i}>
                  <td>{row.sn}</td>
                  <td>{row.name}</td>
                  <td>{row.aadhar}</td>
                  <td>{row.account}</td>
                  <td>{row.amount}</td>
                  <td>{row.factor}</td>
                  <td>{row.source}</td>
                  <td>{row.approvedBy}</td>
                  <td>{row.requestedBy}</td>
                  <td>{row.requestedDate}</td>
                  <td>{row.approvalDate}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </section>
    </div>
  );
}
